import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  isLoading,
  getCoursesResults,
  getCoursesMetaData,
  getCenter,
  getAddress,
} from "../../store/selectors/search";
import { searchCourses, changeAddress } from "../../store/actions/search";

import PampersSearch from "./PampersSearch";

/* Deliberately does not map the shared `filters` slice: it is persisted and
 * belongs to /search, so this page keeps its own filter state instead. */
const mapStateToProps = state => ({
  isLoading: isLoading(state),
  results: getCoursesResults(state),
  metadata: getCoursesMetaData(state),
  center: getCenter(state),
  address: getAddress(state),
});

const mapDispatchToProps = {
  searchCourses,
  changeAddress,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PampersSearch));
